const MONTH_FEE_PERCENTAGE = 8;

export default function getMonthlyPrice(anualPrice: number): number {
  return ((1 + MONTH_FEE_PERCENTAGE / 100) * anualPrice) / 12;
}
